<template>
  <div class="order">
    <!-- Add your template content here -->
    <div class="order-details">
      <div class="order-header">
        <img class="order-img" :src="getOrderImage" />
        <span class="order-title">{{ payStatusText }}</span>

        <div v-if="refundStatus==2||refundStatus==3" class="top_remark">
          <span class="text-top-left">退款金额</span>
          <div class="top_right">
            <span v-if="refundStatus==2" class="text-top_text">￥{{refundAmount}}资金将原路退回</span>
            <span v-if="refundStatus==3" class="text-top_text">￥{{refundAmount}}</span>
          </div>
        </div>

        <span v-if="refundStatus==4||refundStatus==5" class="top-remark-text">请联系客服处理！</span>

      </div>

      <div class="line20"></div>

      <div class="order-bottom">

        <div class="order-content">
          <div class="product-name">
            <img class="product-img" :src="this.picUrl" />
            <div class="product-info">
              <span class="product-info-text">{{ orderType==='D'? modelName : name }}</span>
              <span class="product-info-text2">{{ orderType==='D'? sn : packageDesc }}</span>
            </div>
          </div>
        </div>

        <div class="line"></div>

        <div class="order-detail-item">
          <span class="text-detail-left">退款金额</span>
          <span class="text-detail-right">¥{{ refundAmount }}</span>
        </div>
        <div class="order-detail-item">
          <span class="text-detail-left">退款单号</span>
          <span class="text-detail-right">{{ refundOrderId }}</span>
        </div>
        <div v-if="refundStatus==3" class="order-detail-item">
          <span class="text-detail-left">退款时间</span>
          <span class="text-detail-right">{{ refundTime }}</span>
        </div>
        <div v-if="refundStatus==3" class="order-detail-item">
          <span class="text-detail-left">退款渠道</span>
          <span class="text-detail-right">{{ refundChannel }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderRefundDetail } from "@/api/user";

export default {
  name: "OrderDetails",
  data() {
    return {
      // Add your component data here
      picUrl: "", //图片地址
      name: "", //商品名称
      packageDesc: "", //商品描述
      refundOrderId:"",//退款订单id
      refundStatus:"",//退款状态，2-退款处理中，3-退款成功，4-退款异常，5-退款失败
      refundAmount:"",//退款金额
      refundTime:"",//退款时间
      refundChannel:"",//退款渠道 1-原路退回，2-线下退款
      orderType:"",//订单类型
      modelName:"",
      sn:"",
    };
  },

  computed: {
    getOrderImage() {
      // 定义状态与图片的映射关系
      const statusImages = {
        1: require("@/assets/order_img.png"), // 已完成
        2: require("@/assets/order_tking_img.png"),   // 退款处理中
        3: require("@/assets/order_img.png"), // 退款成功
        4: require("@/assets/order_tkyc_img.png"), // 退款异常
        5: require("@/assets/order_tksb_img.png"), // 退款失败
      };
      // 返回匹配的图片，若无匹配则用默认图
      return statusImages[this.refundStatus];
    },
    payStatusText() {
      return this.refundStatus === 1
        ? "交易成功"
        : this.refundStatus === 2
        ? "退款处理中"
        : this.refundStatus === 3
        ? "退款成功"
        : this.refundStatus === 4
        ? "退款异常"
        : this.refundStatus === 5
        ? "退款失败"
        : "-";
    },
    
  },
  methods: {
    // Add your component methods here
    getOrderRefund() {
      getOrderRefundDetail({ refundOrderNo: this.$route.query.refundOrderNo })
        .then((res) => {
          console.log("获取退款详情成功：" + res);
          this.picUrl = res.picUrl;
          this.refundOrderId = res.refundOrderId; //退款订单id
          this.refundStatus = res.refundStatus;//退款状态，2-退款处理中，3-退款成功，4-退款异常，5-退款失败
          this.refundAmount = res.refundAmount;//退款金额
          this.refundTime = res.refundTime;//退款时间
          this.refundChannel = res.refundChannel;//退款渠道
          this.orderType = res.orderType;
          this.modelName = res.modelName?res.modelName:"";
          this.sn = res.sn?res.sn:"";
          this.name = res.trafficPackageInfo.name?res.trafficPackageInfo.name:"";
          this.packageDesc = res.trafficPackageInfo.packageDesc?res.trafficPackageInfo.packageDesc:"";
        })
        .catch((err) => {
          console.error("获取退款详情失败：" + err);
        });
    },
  },
  mounted() {
    // Add your mounted logic here
    this.getOrderRefund();
  },
};
</script>

<style lang="less" scoped>
.order {
  /* Add your styles here */
  height: 100%;
  background: white;
  .order-details {
    flex-direction: column;
    display: flex;
    .order-header {
      background: white;
      height: 326px;
      align-items: center;
      display: flex;
      flex-direction: column;
      .order-title {
        font-size: 36px;
        color: #000000;
        margin-top: 20px;
        font-weight: bold;
      }
      .order-img {
        width: 96px;
        height: 96px;
        margin-top: 80px;
      }
      .top-remark-text{
        font-size: 28px;
        color: var(--primary-color);
        margin-top: 20px;
      }
      .top_remark{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        margin-top: 20px;
        .text-top-left{
          font-size: 26px;
          color: #848992;
          margin-left: 32px;
        }
        .top_right{
          display: flex;
          flex-direction: row;
          margin-right: 32px;
          .text-top_text{
            font-weight: bold;
            font-size: 28px;
            color: var(--primary-color);
            text-align: right;
          }
          .right-img{
            width: 36px;
            height: 36px;
          }
        }
      }
    }
  }
  .line20 {
    height: 20px;
    background: #f2f2f2;
  }
  .order-bottom {
    background: white;
    display: flex;
    flex: 1;
    flex-direction: column;
    .order-bottom-item {
      display: flex;
      align-items: center;
      padding-left: 30px;
      padding-right: 40px;
      height: 100px;
      .order-img-line {
        width: 6px;
        height: 24px;
      }
      .text-bottom {
        font-size: 32px;
        color: #000000;
        padding-left: 24px;
        font-weight: bold;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 6px;
          height: 24px;
          background: var(--primary-color);
          border-radius: 12px;
        }
      }
    }
    .order-content {
      display: flex;
      justify-content: space-between;
      padding-left: 40px;
      padding-right: 40px;
      padding-top: 20px;
      .product-name {
        display: flex;
        flex-direction: row;
        margin-right: 30px;
        .product-img {
          width: 132px;
          height: 132px;
        }
        .product-info {
          margin-left: 16px;
          display: flex;
          flex-direction: column;
          .product-info-text {
            font-size: 30px;
            color: #000000;
          }
          .product-info-text2 {
            font-size: 26px;
            color: #848992;
            margin-top: 8px;
          }
        }
      }
      .price-section {
        display: flex;
        flex-direction: column;
        text-align: right;
        .price-label {
          font-size: 30px;
          color: #000000;
        }
        .price-value {
          font-size: 26px;
          color: #848992;
          margin-top: 12px;
          align-items: right;
        }
      }
    }
    .line {
      height: 1px;
      background: #f1f1f1;
      margin-top: 32px;
      margin-left: 30px;
      margin-right: 30px;
    }
    .order-detail-item {
      display: flex;
      justify-content: space-between;
      padding-left: 40px;
      padding-right: 40px;
      padding-top: 20px;
      .text-detail-left {
        font-size: 26px;
        color: #848992;
      }
      .text-detail-right {
        font-size: 26px;
        color: #000000;
      }
    }
  }
}
</style>
